import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.widget.all.cage');
import { Input } from '@angular/core';

@Component({
    selector: 'wiz-component-widget-all-cage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.widget.all.cage/view.scss */
/* src/app/component.widget.all.cage/view.scss: no such file or directory */`],
})
export class ComponentWidgetAllCageComponent {

    @Input() value: number | null = null;
}

export default ComponentWidgetAllCageComponent;